import { useSyncExternalStore } from "react";
import { foundMedia } from "@/lib/voice/foundMedia";
import type { GenieAttachment } from "@/types/voice/genie-attachment";

/** Every link and picture the Genie found in this conversation, best first. */
export const useFoundMedia = (): GenieAttachment[] =>
  useSyncExternalStore(foundMedia.subscribe, foundMedia.list, foundMedia.list);
